import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainPageComponent } from './features/main-page/main-page.component';
import { CustomerNotificationDetailsComponent } from './features/customer-notification-details/customer-notification-details.component';
import { CustomerContactDetailsComponent } from './features/customer-contact-details/customer-contact-details.component';
import { NondialogCustomerWelcomeComponent } from './features/nondialog-customer-welcome/nondialog-customer-welcome.component';

export const routes: Routes = [
  {
    path: ':country/:language',
    children: [
      {
        path: 'main',
        component: MainPageComponent,
        pathMatch: 'full'
      },
      {
        path: 'customer-notification-details',
        component: CustomerNotificationDetailsComponent,
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: 'main',
      },
    ],
  },
  {
    path: 'main',
    component: MainPageComponent,
    pathMatch: 'full'
  },
  {
    path: 'customer-notification-details',
    component: CustomerNotificationDetailsComponent,
    pathMatch: 'full'
  },
  {
    path: 'contact-details',
    component: CustomerContactDetailsComponent,
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    component: NondialogCustomerWelcomeComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'main',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
